import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="header">
        <div className="profile-photo">
          <img src="/profile.png" alt="Chihosong" />
        </div>
        <h1>Chiho Song</h1>
        <p className="title">Backend Engineer</p>
        <div className="header-links">
          <a href="https://github.com/songtov" target="_blank" rel="noopener noreferrer">GitHub</a>
          <a href="https://linkedin.com/in/chiho-song-772aa0291" target="_blank" rel="noopener noreferrer">LinkedIn</a>
          <a href="https://chihosong.notion.site/Chiho-Song-f528414d9d1e42098c33021e46c2435e?pvs=4" target="_blank" rel="noopener noreferrer">Notion</a>
        </div>
      </header>

      <main className="main-content">
        <section className="about">
          <h2>About Me</h2>
          <div className="about-content">
            <p>Backend Engineer with 3+ years of experience building and maintaining robust backend systems using Python (FastAPI), Ruby on Rails, AWS, and GCP. Passionate about exploring and creating systems that scale, I enjoy solving complex engineering challenges and delivering practical solutions. I'm results-driven—focused not just on clean code, but on building products that generate value and revenue. With a strong foundation from the Hebrew University, I approach obstacles as opportunities and consistently find ways to break through and deliver.</p>
            <div className="skills">
              <span className="skill-tag">Python</span>
              <span className="skill-tag">Postgresql</span>
              <span className="skill-tag">FastAPI</span>
              <span className="skill-tag">Rails</span>
              <span className="skill-tag">AWS</span>
              <span className="skill-tag">Docker</span>
              <span className="skill-tag">SQL</span>
              <span className="skill-tag">REST APIs</span>
            </div>
          </div>
        </section>

        <section className="projects">
          <h2>Featured Projects</h2>
          <div className="project-list">
            <div className="project-item">
              <h3>SAML SSO</h3>
              <p>A SAML SSO implementation for a web application. Built with Ruby on Rails and deployed on AWS.</p>
              <div className="project-links">
                <a href="#" target="_blank" rel="noopener noreferrer">View Demo</a>
                <a href="#" target="_blank" rel="noopener noreferrer">Source Code</a>
              </div>
            </div>
            <div className="project-item">
              <h3>CS-Admin</h3>
              <p>An internal web application that allows CS team to manage the company's products. Built with FastAPI and deployed on K3s.</p>
              <div className="project-links">
                <a href="#" target="_blank" rel="noopener noreferrer">View Demo</a>
                <a href="#" target="_blank" rel="noopener noreferrer">Source Code</a>
              </div>
            </div>
          </div>
        </section>

        <section className="education">
          <h2>Education</h2>
          <div className="education-list">
            <div className="education-item">
              <h3>Hebrew University of Jerusalem</h3>
              <p className="degree">Bachelor of Science in Computer Science and Mathematics</p>
              <p className="year">2018 - 2023</p>
              <p className="description">Studied in Hebrew and graduated with a GPA of 80</p>
            </div>
          </div>
        </section>

        <section className="resume">
          <h2>Resume</h2>
          <p>Download my detailed resume to learn more about my experience, skills, and achievements.</p>
          <a href="/chihosong_resume.pdf" download className="resume-link">Download Resume</a>
        </section>
      </main>

      <footer className="footer">
        <p>© {new Date().getFullYear()} Chihosong. All rights reserved.</p>
        <div className="social-links">
          <a href="mailto:songchiho777@gmail.com">Email</a>
          <a href="https://github.com/songtov" target="_blank" rel="noopener noreferrer">GitHub</a>
          <a href="https://linkedin.com/in/chiho-song-772aa0291" target="_blank" rel="noopener noreferrer">LinkedIn</a>
        </div>
      </footer>
    </div>
  );
}

export default App;
